module.exports = __webpack_public_path__ + "img/24.6ee3f6b7.jpg";